<script setup lang="ts">

</script>

<template>
	<div class="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 xl:gap-20 mb-8 lg:mb-16">
		<div class="lg:col-span-12 min-h-80">
			<h1 class="text-black [&_span]:text-accent text-center mb-10 lg:mb-12 xl:mb-16">
				404 <span class="block">Diese Leitung endet im Nichts.</span>
			</h1>
			<p class="w-full lg:w-[80%] xl:w-[66%] flex mx-auto text-center text-[16px] sm:text-[18px] lg:text-[20px] xl:text-[24px] mb-12">Kein Anschluss unter dieser Adresse. Die Seite wurde verlegt, umbenannt oder liegt noch im Rohbau.</p>

			<GameRohrsprung class="mb-4" />

			<p class="text-sm text-center text-gray-600 mb-12">
				<span class="border border-gray-400 px-1 py-0.5 rounded-sm text-primary font-medium">Leertaste</span> springt, <span class="inline-flex border border-gray-400 px-1 py-0.5 rounded-sm"><GsIcon name="mdi-arrow-down" class=" inline-block text-primary" /></span> duckt weg.
			</p>

			<div>
				<p class="text-center text-[16px] sm:text-[18px] lg:text-[20px] xl:text-[24px] mb-12">
					<NuxtLink to="/" class="flex items-center justify-center  font-medium text-primary hover:text-accent focus-visible:text-accent">
						<GsIcon name="mdi-arrow-right" class="inline-block mr-2 my-auto" />
						<span>Zurück zur Startseite</span>
					</NuxtLink>
				</p>
			</div>
		</div>
	</div>
</template>
